import React, { Component } from 'react';

import { CountrySelect, CitySelect } from 'components/blocks/geo';


export default class GeoFieldSet extends Component {
    state = {
        countryId: null,
    };

    handleCountryChange = (value) => {
        this.setState({
            countryId: value,
        })
    };

    render() {
        const { form, agency } = this.props;
        const { updateStatus, editObject } = agency;
        const instance = editObject;
        const countryId = this.state.countryId || (instance && instance.country);
        const cityActiveFilter = countryId ? { country: countryId } : null;

        const error = updateStatus.error || {};
        const errorData = error.data || {};

        return (
            <div className="form-block">
                <CountrySelect
                    form={form}
                    instance={instance}
                    name="country"
                    label="Страна"
                    required={true}
                    errorData={errorData}
                    onChange={this.handleCountryChange}
                />

                <CitySelect
                    form={form}
                    instance={instance}
                    name="city"
                    label="Город"
                    required={true}
                    errorData={errorData}
                    activeFilter={cityActiveFilter}
                />
            </div>
        );
    }
}
